import React from "react";

import AssetIcon from "./AssetIcon";

const AssetIconAlert = () => {
  return (
    <AssetIcon backgroundColor="orange">
      <svg viewBox="0 0 10 10">
        <polygon points="5,2 1,8 9,8 " />
      </svg>
    </AssetIcon>
  );
};

export default AssetIconAlert;
